import { BOOKS_SAVEMARKS_ENDPOINT } from "../Constants/Endpoints";
import { apiCallJson } from "../Helpers";

export async function getAllLogsAsync(
  pageNumber,
  recordsPerPage,
  propSort,
  descending,
  filter
) {
  let filterQuery = "";
  if (filter) {
    filter.forEach((element) => {
      if (element.value) {
        filterQuery += "&" + element.key + "=" + element.value;
      }
    });
  }

  return await apiCallJson(
    "/Logs/all" +
      "?pageNumber=" +
      pageNumber +
      "&recordsPerPage=" +
      recordsPerPage +
      "&sortProp=" +
      propSort +
      "&descending=" +
      descending +
      filterQuery,
    "GET",
    null
  );
}

export async function getAllLogsCountAsync() {
  return await apiCallJson("/Logs/count", "GET", null);
}

export async function getStudentBooksLogsRequest(userId) {
  return await apiCallJson(
    BOOKS_SAVEMARKS_ENDPOINT + "?userId=" + userId,
    "GET",
    null
  );
}
